<template>
  <header class="skill-header">
    <button class="skill-header__back" type="button" @click="$emit('back')">
      <img src="@/assets/images/skillCenterQuestion/back.png" alt="返回">
    </button>
    <div class="skill-header__title" :class="{ 'skill-header__title--left': titleAlign === 'left' }">{{ title }}</div>
    <div class="skill-header__right"><slot /></div>
  </header>
</template>

<script>
export default {
  name: 'SkillCenterQuestionHeader',
  props: {
    title: {
      type: String,
      default: ''
    },
    titleAlign: {
      type: String,
      default: 'center'
    }
  }
}
</script>

<style lang="scss" scoped>
.skill-header {
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: 88px;
  padding: 0 20px 11px;
  flex: none;
  box-sizing: border-box;
  font-family: -apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei", sans-serif;
}

.skill-header__title {
  max-width: 255px;
  overflow: hidden;
  color: #111111;
  font-size: 17px;
  font-weight: 600;
  line-height: 24px;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.skill-header__title--left {
  position: absolute;
  left: 48px;
  max-width: 263px;
  text-align: left;
}

.skill-header__back,
.skill-header__right {
  position: absolute;
}

.skill-header__back {
  bottom: 13px;
  left: 16px;
  width: 20px;
  height: 20px;
  padding: 0;
  border: 0;
  background: transparent;
}

.skill-header__back img {
  display: block;
  width: 20px;
  height: 20px;
  object-fit: contain;
}

.skill-header__right {
  right: 18px;
  bottom: 9px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  width: 32px;
  height: 28px;
}
</style>
